import React from 'react'
import NavBar from '../NavBar'
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row ,Card} from 'react-bootstrap'
import bgimage from '../DetailsProduct/imeages/bgimage.jpg'
import imege2  from '../DetailsProduct/imeages/Qaimage.png'
import imege1 from '../DetailsProduct/imeages/qualitycontrrol.avif' 
import '../App.css'
import { useTheme } from '../ThemeContext';
import Footer from '../Footer';
import {  FaServer, FaDatabase, FaLaptopCode, FaPlus, FaVials, FaTable, FaChartLine, FaFileAlt, FaSync } from "react-icons/fa";
import {FaComputer} from 'react-icons/fa6'

const QualtityControl = () => {
  const models = [
    {
      title: "Masters Management - Capture exhaustive details",
      icon: <FaPlus size={30}/>,
      features: ["Analyzer Master", 
                  "QC Sera Master"],
                  isLeft: true
    },
    
    {
      title: "QC Sera Preparation & Scheduling",
      icon: <FaVials size={30} />,
      features: [
        "Prepare QC Samples for future use, with complete traceability",
        "Define Schedule and use samples accordingly",
        "Run QC as planned",
      ],
      isLeft: false
    },
    {
      title: "Define UOM, Lab Mean",
      icon: <FaTable size={30}/>,
      features: [
        "Define UOM and run QC",
        "Run Samples & Establish Lab Mean",
        "Exclude values (outlier) if needed",
        "Calculate SD & CV",
      ],
      isLeft: true
    },
    {
      title: "Automatic LJ Plot",
      icon: <FaChartLine size={30}  />,
      features: [
        "Plot LJ Graph automatically and visualize them on demand",
        "Implement Westgard Rules",
      ],
      isLeft: false
    },
    {
      title: "Integration & MIS Reports",
      icon: <FaFileAlt size={30} />,
      features: [
        "Integrate with any lab analyzers",
        "Clearly identify patient samples & QC Samples",
        "Get in-depth analysis of reports",
      ],
      isLeft: true
    },
    {
      title: "Continuous Process Improvement",
      icon: <FaSync size={30}  />,
      features: [
        "Implement Westgard Rules",
        "Walk-back on need basis to narrow down errors",
      ],
      isLeft: false
    },
  ];
  
   const sections = [
      {
        title: "Front End",
        icon: <FaLaptopCode size={50} style={{ opacity: 0.7 }}  />,
        points: [
          "Angular 14 & HTML5 with continuous upgrade to latest versions",
          "Faster, Scalable, enabling Easy Adoption",
        ],
      },
      {
        title: "Server Side",
                

        icon: <FaComputer size={50} style={{ opacity: 0.7 }}  />,
        points: [
          "Web API, .Net Core MVC",
          "Improved Performance of Application, Scalable & Robust",
        ],
      },
      {
        title: "Back End",

        icon: <FaDatabase size={50} style={{ opacity: 0.7 }}/>,
        points: [
          " SQL-Scalable and Elastic InfrastructureIn built Features for enhanced datasecurity ",
          "Depending on the customer preference,we provide flexibility to choose between SQL/MY SQL/Postgre",
          "On a case to case basis we offer ORACLEDB assistance at additional cost"
        ],
      },
    ];
  const {theme} = useTheme()
  return (
<div style={{
        backgroundColor: theme === "dark" ? "#1e1e1e" : "",
        minHeight: "100vh", marginTop:'40px'
      }}>
        <NavBar />
   


    <Container fluid className="py-5 contain"
     style={{
      // backgroundImage:`url(${bgimage})`,
      backgroundImage: theme === "light" ? "" : "none",
      backgroundColor: theme === "dark" ? "#1e1e1e" : "none",
      backgroundSize: 'cover', 
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
        // filter: "blur(1px)",
      // height:'100%',
      // width:'100%'
       opacity:'0.9'
    }}
    > 
    <div className='content'>
      <Container>
        <Row className="d-flex justify-content-center align-items-center">
          {/* Text Section */}
          <Col xs={12} md={8}  className="text-center text-md-start">
            <h1 className="fw-bold text-capitalize text-decoration-underline">
            Quality Control Systems <br />
              <span></span>
            </h1>
            <h4 className=" mt-3 fw-bold text-primary">BBT Labs</h4>
            <p className='fs-4'>
            BBT Labs QC is a plug & play solution that can work with both <br />
            our LIS and any 3rd party LIS. The QC Modules enables <br />
            establishing SOP’s, visualizing data and taking decisions based
             on data
            </p>
          </Col>

          {/* Image Section */}
          <Col xs={12} md={4} className="text-center align-items-start">
            <img
           style={{marginTop:'20%',marginRight:'40%',width:"400px",height:"400px",objectFit:"cover" }}
                         src={imege1} 
                         alt="Scientist illustration"
                         className="rounded-circle img-fluid mx-auto d-block"
              // style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
            />
          </Col>
        </Row>

      </Container>

      <Container className='py-5'>
         <h4 className='text-center text-primary'>CLINICALLY ACCURATE REPORTS TO YOUR PATIENTS-EVERY TIME</h4>
          <Row className='align-items-start'>
            <Col md={4} xs={12} className='mt-5'>
              <img 
              src={imege2}
              alt=" image2"
              className="img-fluid"
              />
            </Col >
            <Col md={8} xs={12} style={{marginTop:'40px'}}>
              <ul className=' list-unstyled '>
                <li className=''>➤ Capture QC Sera Attributes from
Manufacturer in robust master screen
with exhaustive details
    </li>         
                  <li>➤ Define QC Schedule according to needs </li>
             
                <li className=''>➤ Aliquote & prepare QC Sample </li>
                <li>➤ Establish Lab Mean & SD(exclude outliers)</li>
                <li>➤  Plot LJ Graph and View them as needed
                     for “n” number of parameters
                  </li>
                <li>
                ➤ Implement Westgard Rules 
                </li>
                <li>
                ➤ Provide Clinically Accurate Report
                </li>
                <li>
                ➤  Walk-back & Analyze Data
                </li>
              </ul>
            
            </Col>
          </Row>
       </Container>
       <Container fluid>
        <h4 className='text-center text-primary mb-3'>HIGH LEVEL MODELS </h4>
        <Row className="justify-content-center">
        {models.map((model, index) => (
          <Col md={5} sm={12} key={index} className="">
            <Card className="d-flex flex-row align-items-center shadow-sm p-3 mb-2"style={{ borderTopLeftRadius: model.isLeft ? "50px" : "0px",
    borderBottomLeftRadius: model.isLeft ? "50px" : "0px",
    borderTopRightRadius: model.isLeft ? "0px" : "50px",
    borderBottomRightRadius: model.isLeft ? "0px" : "50px",
    minHeight: "200px"}}>
              <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px", fontSize: "1.5rem" }}>
                {model.icon}
              </div>
              <div className="ms-3">
                <h5 className="mb-2">{model.title}</h5>
                {/* <p className="mb-0 text-muted">{model.features}</p> */}
                <ul className='list-unstyled'>
                {model.features.map((item,idx)=>(
                  <li key={idx}>➤ {item}</li>
                ))}
                </ul>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

  </Container>
  <Container fluid >
              <h2 className='text-primary text-pperase text-center mb-3 mt-3'>TECHNOLOGY STACK </h2>
              
              <Row className="justify-content-center">
              {sections.map((section,index)=>(
                 <Col md={4} xs={12} key={index}  className='mb-2'  >
                    <Card className='shadow-sm border-0' style={{minHeight:'330px'}}>
                      <Card.Header className='text-center text-dark fw-bold fs-5'>
                        {section.icon}
                        {/* {section.title} */}
                      </Card.Header>
                                               <h5 className='fw-bold mt-3 ms-4'>{section.title}</h5>

                      <Card.Body>
                        <ul className='list-unstyled'>
                          {section.points.map((item,idx)=>(
                            <li key={idx}>➤ {item}</li>
                          ))}
                        </ul>
                      </Card.Body>
                    </Card>

                 </Col>
              ))}

                

              </Row>

       </Container>
       </div>
       </Container>
       <Footer />
       </div>
      )
}

export default QualtityControl